<template>
  <b-overlay :show="show" rounded="sm">
    <div class="auth-wrapper auth-v1 px-2">
      <div class="auth-inner py-2">
        <!-- Forgot Password v1 -->
        <b-card class="mb-0">
          <div class="d-flex align-items-center">
            <b-link class="brand-logo">
              <!-- logo -->
              <vuexy-logo />
              <h2 class="brand-text text-primary ml-1">
                {{ $t("adminPage") }}
              </h2>
            </b-link>
            <vue-locale />
          </div>

          <b-card-title class="mb-1">
            {{ $t("forgotPassword") }} 🔒
          </b-card-title>

          <!-- <b-card-text class="mb-2">
            {{ $t("enter") }}
          </b-card-text> -->

          <!-- form -->
          <validation-observer ref="simpleRules">
            <b-form
              class="auth-forgot-password-form mt-2"
              @submit.prevent="validationForm"
            >
              <!-- email -->
              <b-form-group
                :label="$t('usernameorEmail')"
                label-for="forgot-password-email"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Username or Email"
                  rules="required"
                >
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="example or john@example.com"
                  />
                  <small v-show="errors.length > 0" class="text-danger">{{
                    errors[0]
                  }}</small>
                </validation-provider>
              </b-form-group>

              <!-- submit button -->
              <b-button variant="primary" block type="submit">
                {{ $t("sendLink") }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{ name: 'auth-login' }">
              <feather-icon icon="ChevronLeftIcon" />{{ $t("backLogin") }}
            </b-link>
          </b-card-text>
        </b-card>
        <!-- /Forgot Password v1 -->
      </div>
    </div>
  </b-overlay>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import VueLocale from "@core/layouts/components/app-navbar/components/LocaleSmall.vue";
import {
  BCard,
  BLink,
  BCardText,
  BCardTitle,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BOverlay,
  
} from "bootstrap-vue";

import useJwt from "@/auth/jwt/useJwt";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { POSITION } from "vue-toastification";
export default {
  components: {
    VuexyLogo,
    BCard,
    BLink,
    BCardText,
    BCardTitle,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    ValidationProvider,
    ValidationObserver,
    BOverlay,
    VueLocale
  },
  data() {
    return {
      userEmail: "",
      show: false,
      email,
    };
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          // reset-password
          this.show = !this.show;

          useJwt
            .get("reset-password", {
              params: {
                email: this.userEmail,
              },
            })
            .then((response) => {
              this.$swal(
                this.$i18n.t("success"),
                "The require is successfully created. Please check the email address connected to your account for a password reset email.",
                "success"
              );
              this.$router.push({ name: "auth-login" });
            })
            .catch((error) => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: "Lỗi vui lòng thử lại sau ",
                  icon: "AlertTriangleIcon",
                  variant: "danger",
                },
              });
            });
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style scoped>
span.text-body{
  display:none
}
li{
  list-style: none;
}
</style>